export default __webpack_public_path__ + "static/KanhaM-05659291bea1b750f863937acffd91f3.jpg";